import styles from '../css/login_new.scss';

import LoginNews from './components-vue2/Login/LoginNews.vue';
import Raven from 'raven-js';

// window.raven is setup in login.html
Raven.config(window.raven.dsn, {
    environment: window.raven.environment,
    release: window.raven.release,
    tags: {
        frontend: 'dentist_frontend',
    },
}).install();
Raven.setUserContext({
    ip_address: window.raven.client_ip,
});
window.Raven = Raven;

const vm = new Vue({
    el: '#news-list',
    template: '<login-news></login-news>',
    components: {LoginNews},
});



// WEBPACK FOOTER //
// ./src/login.js